import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter} from 'react-router-dom';
import RedirectPage from './components/RedirectPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
const redirect = true;

root.render(
  <React.StrictMode>
    <BrowserRouter>
    {redirect ? <RedirectPage /> : <App />}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
